
import Vue from 'vue';
import { mapMutations } from 'vuex';

export default Vue.extend({
  name: 'CommonApiMixin',

  methods: {
       axiosServiceSend(data, url, method, type, other, time){
        console.log('CommonApiMixin',data, url, method, type, other)
        const responseType = (other == null || other=== undefined) ||
         (other.responseType === null || other.responseType === undefined) ? '' : other.responseType;
        const timeout = (time == null || time=== undefined) ? 0 : time
        this.axios({
          url: url,
          method: method,
          data: data,
          responseType: responseType,
          timeout: timeout,
        })
          .then((res) => {
            // console.log(res);
            this.response = res;
            console.log('other', other)
            this.success(type, res, other);
            return res;
          })
          .catch((error) => {
            // console.log(error);
            this.error = error
            this.fail(type, error, other);
            return error;
          });
      },
      success(type,res, other) {
        console.log(type,res,other);
      },
      fail(type,error, other) {
        console.log(type,error,other);
      },
      ...mapMutations({
        apiStart: 'api/start',
        apiStop: 'api/stop',
      }),
    },
});
